import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "appointmentContent pad20 with_white_bg rad20 mt20" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = { class: "mt20" }
const _hoisted_6 = { class: "fs20 fw600 fl" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "fs24 fw600 arial mt10"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "分", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "fs20 fw600 arial mt10"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = ["src"]
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  class: "appointmentAttendeesContent",
  style: {"margin-top":"30px"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "fs12 ddgrey fw600" }, "オーナー", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = {
  key: 0,
  style: {"margin-top":"6px"}
}
const _hoisted_23 = { style: {"margin":"8px"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "fs12 ddgrey fw600" }, "出席予定者", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = {
  key: 0,
  style: {"margin-top":"6px"}
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb10" }, null, -1)
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "circle_button fw600 posAb fs20 dskyblue",
  style: {"top":"160px","left":"40px"}
}, "会議場所を設定", -1)
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = { class: "w100" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs13 fw600",
  style: {"margin-top":"30px"}
}, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { key: 3 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = { class: "w100 pad20 fw600 mt20 centered llgreyBg" }
const _hoisted_43 = {
  style: {"line-height":"23px"},
  class: "mt10 centered w100"
}
const _hoisted_44 = { class: "fs12 ddgrey fw600" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = { class: "fs18 fw600 ddgrey" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "ml10" }, "様からのメッセージ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = {
  class: "fs13 kaigyo rad8 mt5",
  style: {"padding":"30px 0px"}
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`ScheduleCenterContent withEditable`),
  style: {"min-width":"700px"}
}
const _hoisted_52 = {
  class: "w100 pad20 fw600 llgreyBg",
  style: {"height":"100px"}
}
const _hoisted_53 = {
  key: 1,
  style: {"line-height":"23px"},
  class: "fl mt10 ml15"
}
const _hoisted_54 = { class: "fs12 ddgrey fw600" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = { class: "fs18 fw600 ddgrey" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "ml10" }, "様からのメッセージ", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = {
  class: "fs13 kaigyo rad8 mt5",
  style: {"padding":"36px 30px"}
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = {
  class: "centered grey fs12 posAb",
  style: {"bottom":"0","margin":"10px 45%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconGear = _resolveComponent("IconGear")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_EditableZoomSettings = _resolveComponent("EditableZoomSettings")!
  const _component_AppealContentSettings = _resolveComponent("AppealContentSettings")!
  const _component_ScheduleMainContent = _resolveComponent("ScheduleMainContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", {
      class: _normalizeClass(`AvailableTimeContent posAb`),
      style: _normalizeStyle({
                display: `flex`,
                justifyContent: `flex-end`,
                marginTop: _ctx.isGuest ? `0` : `68px`,
            })
    }, [
      (_ctx.rcm && _ctx.rcm.room)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: _normalizeClass(`ScheduleFixContent ofh ${_ctx.isSP ? `pad20` : `mt10`} posRe`),
            style: _normalizeStyle({
                    boxShadow: `0`,
                    marginLeft: _ctx.isSP ? `` : `100px`,
                })
          }, [
            (_ctx.rcm.appo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_IconGear, {
                      width: 33,
                      class: "fl pointer",
                      tooltipText: `会議時間の詳細を設定します`,
                      onClick: _ctx.editAppoInfo
                    }, null, 8, ["onClick"]),
                    _hoisted_4,
                    _createElementVNode("div", {
                      class: "appointmentContentInner withEditable posRe",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editAppoInfo && _ctx.editAppoInfo(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, "■ " + _toDisplayString(_ctx.rcm.appo.name), 1)
                      ]),
                      _hoisted_7,
                      (_ctx.rcm.appo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/watch2.png`),
                                width: "16",
                                height: "16",
                                class: "fl mr7 mt6 ml2"
                              }, null, 8, _hoisted_9),
                              _createTextVNode(" " + _toDisplayString(_ctx.rcm.appo.duration) + " ", 1),
                              _hoisted_10
                            ]),
                            _hoisted_11
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.rcm.room_setting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/box_two.png`),
                                width: "18",
                                height: "18",
                                class: "fl mr7 mt2"
                              }, null, 8, _hoisted_13),
                              _createTextVNode(" " + _toDisplayString(_ctx.stepSizeText), 1)
                            ]),
                            _hoisted_14
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_15
                    ]),
                    (_ctx.rcm.appo.location_name)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "fs16 appoLocation withEditable posRe mt15",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editLocations && _ctx.editLocations(...args)))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/mappin.png`),
                            width: "18",
                            height: "18",
                            class: "fl mr5"
                          }, null, 8, _hoisted_16),
                          (_ctx.Util.isUrl(_ctx.rcm.appo.location_name))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: `${_ctx.rcm.appo.location_name}`,
                                target: "_blank"
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.rcm.appo.location_name), 1)
                              ], 8, _hoisted_17))
                            : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.rcm.appo.location_name), 1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _hoisted_21,
                    (_ctx.rcm.room.owner)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("span", _hoisted_23, [
                            (_ctx.rcm.room.owner)
                              ? (_openBlock(), _createBlock(_component_UserIcon, {
                                  key: 0,
                                  width: 48,
                                  canEdit: false,
                                  member: _ctx.rcm.room.owner,
                                  showTooltip: false,
                                  class: "fl mr5 posRe"
                                }, null, 8, ["member"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_24,
                    _hoisted_25,
                    (_ctx.rcm.room.room_type == `parent_room`)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "editableAttendees withEditable posRe",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editAttendees && _ctx.editAttendees(...args)))
                        }, [
                          _hoisted_26,
                          _hoisted_27,
                          (_ctx.rcm && _ctx.Util.isPresent(_ctx.rcm.attendees))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rcm.attendees, (mem, memindex) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: memindex,
                                      class: _normalizeClass(_ctx.isSP ? `fs11 posRe` : `fs11 fl mr2 posRe`)
                                    }, [
                                      mem
                                        ? (_openBlock(), _createBlock(_component_UserIcon, {
                                            key: 0,
                                            width: 48,
                                            canEdit: false,
                                            member: mem,
                                            showTooltip: true,
                                            class: "fl mr5 posRe mb5"
                                          }, null, 8, ["member"]))
                                        : _createCommentVNode("", true)
                                    ], 2))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_29
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_30
                  ]),
                  _hoisted_31,
                  (_ctx.rcm && _ctx.rcm.appo.location_name)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(`appoLocationImage withEditable posRe mt20 ${_ctx.isSP ? `centered` : `centered`} `),
                        style: _normalizeStyle({
                            width: _ctx.isSP ? `` : `320px`,
                            marginLeft: _ctx.isSP ? `` : `-40px`,
                        }),
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.editLocations && _ctx.editLocations(...args)))
                      }, [
                        _createVNode(_component_IconGear, {
                          width: 28,
                          class: "fl pointer posAb ml40 mt15",
                          tooltipText: `会議時間の詳細を設定します`
                        }),
                        _createElementVNode("img", {
                          src: 
                                _ctx.$getAssetImageUrl(
                                    _ctx.Util.getURLFromAddress(_ctx.LocationTag.getAddressFromCurrentAppo(_ctx.rcm.appo, true), `320x320`)
                                )
                            ,
                          style: {"height":"90%","width":"90%"}
                        }, null, 8, _hoisted_32)
                      ], 6))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(`appoLocationImage withEditable posRe pointer ${_ctx.isSP ? `centered` : `centered`} `),
                        style: _normalizeStyle({
                            width: _ctx.isSP ? `` : `320px`,
                            marginLeft: _ctx.isSP ? `` : `-20px`,
                        }),
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.editLocations && _ctx.editLocations(...args)))
                      }, [
                        _hoisted_33,
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/link/illust_bg_image.png`),
                          style: {"height":"100%","opacity":"0.2"}
                        }, null, 8, _hoisted_34)
                      ], 6)),
                  (_ctx.showZoomSettings)
                    ? (_openBlock(), _createBlock(_component_EditableZoomSettings, { key: 2 }))
                    : _createCommentVNode("", true),
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    (_ctx.type && _ctx.rcm.room)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.isSP && _ctx.rcm && _ctx.rcm.room && _ctx.rcm.appo.memo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _hoisted_41,
                        _createElementVNode("div", _hoisted_42, [
                          (_ctx.rcm.room.owner)
                            ? (_openBlock(), _createBlock(_component_UserIcon, {
                                key: 0,
                                width: 62,
                                canEdit: false,
                                member: _ctx.rcm.room.owner,
                                class: ""
                              }, null, 8, ["member"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.rcm.room.owner.company_name ? _ctx.rcm.room.owner.company_name : ` `), 1),
                            _hoisted_45,
                            _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.rcm.room.owner.name), 1),
                            _hoisted_47
                          ])
                        ]),
                        _hoisted_48,
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.rcm.appo.memo), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _hoisted_50
          ], 6))
        : _createCommentVNode("", true),
      (!_ctx.isSP)
        ? (_openBlock(), _createElementBlock("section", _hoisted_51, [
            (!_ctx.isSP)
              ? (_openBlock(), _createBlock(_component_AppealContentSettings, {
                  key: 0,
                  onEditHeaderImage: _ctx.editHeaderImage,
                  onDeleteHeaderImage: _ctx.deleteHeaderImage,
                  onEditHeaderContent: _ctx.editHeaderContent
                }, null, 8, ["onEditHeaderImage", "onDeleteHeaderImage", "onEditHeaderContent"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ScheduleMainContent, {
              ref: "ScheduleMainContent",
              appo: _ctx.rcm.appo,
              type: _ctx.type,
              room: _ctx.rcm.room,
              parentId: _ctx.parentId,
              getPossibles: _ctx.getPossibles,
              onEditAstag: _ctx.editAstag,
              onEditAppoInfo: _ctx.editAppoInfo
            }, null, 8, ["appo", "type", "room", "parentId", "getPossibles", "onEditAstag", "onEditAppoInfo"]),
            false
              ? (_openBlock(), _createElementBlock("section", {
                  key: 1,
                  class: "ScheduleMessageContent with_white_bg ofs withEditable posRe",
                  style: {"margin-top":"30px","padding":"0"},
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.editMessage && _ctx.editMessage(...args)))
                }, [
                  _createElementVNode("div", _hoisted_52, [
                    (_ctx.rcm.room.owner)
                      ? (_openBlock(), _createBlock(_component_UserIcon, {
                          key: 0,
                          width: 62,
                          canEdit: false,
                          member: _ctx.rcm.room.owner,
                          class: "fl"
                        }, null, 8, ["member"]))
                      : _createCommentVNode("", true),
                    (_ctx.rcm.room.owner)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_53, [
                          _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.rcm.room.owner.company_name ? _ctx.rcm.room.owner.company_name : ` `), 1),
                          _hoisted_55,
                          _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.rcm.room.owner.name), 1),
                          _hoisted_57
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_58,
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.rcm.appo.memo || `メッセージを入力できます`), 1)
                  ]),
                  _hoisted_60
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_61, "© " + _toDisplayString(_ctx.Const.year) + " waaq Inc.", 1)
    ], 4)
  ]))
}